/**
 * Number of ticks/labels to render on the date x-axis of the performance
 * charts. Capping this keeps the labels evenly spaced and prevents
 * crowding when there are many data points.
 */
export const CHART_DATE_TICK_AMOUNT = 6;

const formatDayMonth = (date: Date): string => `${date.getDate()} ${date.toLocaleDateString("en-GB", { month: "short" })}`;

/**
 * Formats a millisecond timestamp into a single-line date, e.g. "17 Apr 2026".
 * Shared by chart tooltips and the x-axis label so both stay in sync.
 */
export const formatChartDate = (time: number): string => {
  const date = new Date(time);
  return `${formatDayMonth(date)} ${date.getFullYear()}`;
};

/**
 * Formats a chart x-axis category (a millisecond timestamp passed as a string)
 * into a two-line label: "<day> <month>" on the first line and the year on the
 * second, e.g. ["17 Apr", "2026"].
 */
export const formatChartDateAxisLabel = (value: string): string[] => {
  const date = new Date(Number(value));
  return [formatDayMonth(date), `${date.getFullYear()}`];
};
